// extracted by mini-css-extract-plugin
export default {"grid":"StrategiesPage_grid__QcCA-","toolbar":"StrategiesPage_toolbar__raxrf","flex":"StrategiesPage_flex__bTwai"};